/*
 * Title : gentleAppSate Object 
 * Author : KimTaeOh 
 * Email : taeoh.kim@gentlepie.com
 * Description: APP의 상태를 관리합니다 서비스 계층에서 APP 상태에 맞는 로직이 구현될 예정입니다 
 * Property Value
 * @id : 봇의 고유번호  
 * @isLogin : 로그인 여부 ( true|false )
 * @persona : 퍼소나 (tomy|papa)
 * @custNo : 회원번호
 * @testMode : 테스트모드 여부 ( true|false )
 * @useBrity : 브리티 가능 여부 ( true|false )
 * @htmlRoot : html Jquery Selector
 * @appRoot : application Container Jquery Selector
 * @conversationRoot : 대화영역 Jquery Selector
 * @appHeaderSelector : 헤더 Jquery Selector
 * @quickMenuSelector : 퀵메뉴 컨테이너 Jquery Selec†or 
 * @quickMenuButtonSelector : 퀵메뉴 버튼 Jquery Selector 
 * @quickMenuListSelector  : 퀵메뉴 목록 Jquery Selector 
 */


import GentleApi from '../common/api';
import GentleLang from '../common/lang';
import GentleComponentBubble from '../component/bubble';
import GentleServiceError from '../service/error';
import Const from '../common/const'
import GentleServiceConsulting from '../service/consulting';

const GentleAppState = Object.create(GentleApi, {
    id: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    isLogin: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    isPc: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    persona: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    lang: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    custNo: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    MaxMasterShip: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    CurrentMastership: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    AtomyUserToken: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    AtomyRefreshToken: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    custName: {
        writable: true,
        configurable: false,
        enumerable: false
    },
    testMode: {
        writable: true,
        configurable: false,
        enumerable: false,
        value: false
    },
    useBrity: {
        writable: true,
        configurable: false,
        enumerable: false,
        value: true
    },
    $htmlRoot: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("#atomy-bot")
    },
    $bodyRoot: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("body.chatbot-start")
    },
    $appRoot: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("#app")
    },
    $conversationRoot: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("div.conversation-area")
    },
    $appHeaderSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("#header")
    },
    $chatConsoleSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("#chatConsole")
    },
    $composerAreaContainerSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("div.composer-area-container")
    },
    $quickMenuSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("div#quick-menu")
    },
    $quickMenuButtonSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("button#quick-menu-button")
    },
    $quickMenuListSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("ul#gentle-quick-menu")
    },
    $loginButtonSelector: {
        writable: false,
        configurable: false,
        enumerable: false,
        value: $("a#member-handler")
    },
    $globalKRButtonSelector: {
        writable: true,
        configurable: true,
        enumerable: true,
        value: $("a#krButton")
    },
    $globalENButtonSelector: {
        writable: true,
        configurable: true,
        enumerable: true,
        value: $("a#enButton")
    },
    isPrd: {
        writable: true,
        configurable: false,
        enumerable: false
    },
})
let ssoUrl = 'https://shop-api-ga.atomy.com/'

// callback version
// BackEnd와 통신후 APP의 상태를 초기화 합니다 
// 언어의 경우 봇의 고유번호로 판단해야 하는데 BackEnd에서 내려줄 방법이 없기 때문에 프론트에서 판단합니다 
GentleAppState.init = function (callback) {
    console.log('GentleAppState.init');
    const locationArray = window.location.pathname.split('/');
    // console.log(locationArray);
    
    // TEST MODE ( 전체 서비스를 확인할 수 있는 모드를 제공합니다 )
    if (locationArray[locationArray.length - 4] == 'webchat-test') {
        this.testMode = true;
        this.ignoreState = true;
        this.testPersona = locationArray[locationArray.length - 3];
        this.testLang = locationArray[locationArray.length - 2];
    } else if (locationArray[locationArray.length - 2] == 'webchat-test') {
        this.testMode = true;
        this.ignoreState = false;
    }

    // 봇고유번호
    this.id = locationArray[locationArray.length - 1];

    // brityConnected Check 
    // localhost 혹은 private ip는 브리티와 통신이 불가능합니다 
    const hostName = window.location.hostname;
    const regex = new RegExp('192\.168\.0\.([1-9]+)');
    if (hostName === 'localhost' || (regex.exec(hostName) && regex.exec(hostName)[1] > 1 && regex.exec(hostName)[1] < 255)) {
        this.useBrity = false;
    }
    else{
        console.log('brity 사용합니다.')
    }


    // 성공시 앱의상태 변경
    this.onSuccess(function (serverData) {
        console.log('init> serverData', serverData);
        // 디바이스 체크
        {
            this.isPc = true; //
            // device detection
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                this.isPc = false;
            }
        }

        // console.log('========================');
        console.log('========================serverData==>',serverData);

        // 명목직급        
        this.MaxMastership = (serverData.Data == null || serverData.Data.MaxMastership === undefined) ? "" : serverData.Data.MaxMastership;
        // 토큰     
        this.AtomyUserToken = (serverData.Data == null || serverData.Data.AtomyUserToken === undefined) ? "" : serverData.Data.AtomyUserToken;

        // 재발급토큰
        this.AtomyRefreshToken = (serverData.Data == null || serverData.Data.AtomyUserToken === undefined) ? "" : serverData.Data.AtomyRefreshToken;
        
        // 레거시유저토큰
        this.LegacyUserToken = (serverData.Data == null || serverData.Data.AtomyUserToken === undefined) ? "" : serverData.Data.LegacyUserToken;

        // 등급
        this.CurrentMastership = (serverData.Data == null || serverData.Data.CurrentMastership === undefined) ? "" : serverData.Data.CurrentMastership;

        // 회원번호 
        this.custNo = (serverData.Data == null || serverData.Data.CustNo === undefined) ? "" : serverData.Data.CustNo;

        // 이름
        this.custName = (serverData.Data == null || serverData.Data.CustName === undefined) ? "" : serverData.Data.CustName;

        // 퍼소나
        this.persona = (serverData.Data == null || serverData.Data.Persona === undefined) ? "papa" : serverData.Data.Persona.toLowerCase();

        // 로그인체크 
        this.isLogin = (serverData.Status === 1) ? true : false;

        this.isPrd = (serverData.ServerProfile == 'prd') ? "prd" : "dev"



        // 개발.운영 상태 (dev|prd)
        if (serverData.ServerProfile == 'default' || serverData.ServerProfile == 'dev' || serverData.ServerProfile == 'prd') {
            this.serverProfile = serverData.ServerProfile;
            GentleAppState.isPrd = serverData.ServerProfile;
            // 로컬용 default는 dev로 정의 
            if (this.serverProfile == 'default') {
                this.serverProfile = 'dev';
            }
        }

        // 언어 (봇고유번호로 구분)
        // 브리티 구조상 고유번호를 내려줄 방법이 없기 때문에 프론트 소스레벨에서 정의
        switch (this.id) {
            case "8a02048a7839be7801783f6951320001": // 개발용 KR BOT 
            case "8a02048a7839be78017842acb5800002": // 상용 KR BOT 
                this.lang = "kr";
                break;
            case "8a0c528a78631f1201791ba26fe70003": // 개발용 EN BOT 
            case "8a0c528a78631f120179110554ce0001": // 상용 EN BOT 
                this.lang = "en";
                break;
        }

        // 테스트 모드 
        if (this.testMode === true && this.ignoreState === true) {
            this.persona = this.testPersona;
            this.lang = this.testLang;
        }


        // App상태 
        // console.log('appState', this);
        // 앱상태변경후 잠금 
        try {
            // console.log("this.serverProfile", this.serverProfile)

            // 퍼소나 . 언어 상태 업데이트 
            if (!this.serverProfile) {
                throw "서버프로필이 정의되지 않았습니다";
            }
            if(this.serverProfile === 'prd'){
                ssoUrl = 'https://shop-api-ga.atomy.com'
            }else if(this.serverProfile === 'dev'){
                ssoUrl = 'https://stg-api.atomyn.kr'
            }else{
                ssoUrl = 'http://localhost:3000'
            }
            console.log("this ssoUrl => ", ssoUrl)

            // 퍼소나 . 언어 상태 업데이트 
            if (!this.persona && !this.lang) {
                throw "퍼소나 혹은 언어가 정의되지 않았습니다";
            } else {
                this.setAppState();
            }

            // 로그인 상태 업데이트
            if (this.isLogin === undefined) {
                throw "로그인 상태가 정의되지 않았습니다";
            } else {
                this.setLoginButton();
            }

            // 폰트 업데이트
            const localFontSize = localStorage.getItem(Const.Storage.fontSize);
            if (localFontSize) {
                this.setAppFont(localFontSize);
            } else {
                this.setAppFont('large');
            }

            // 한영 상태 업데이트
            if (this.lang) {
                this.setGlobalButton();
            }


            // 객체잠금
            Object.freeze(this);

            // 콜백수행 
            if (callback !== undefined) {
                try {
                    callback();
                } catch (error) {
                    GentleServiceError.createErrorHandler('service', error);
                }
            }

        } catch (error) {

            GentleServiceError.createErrorHandler('system', error);

        }
    });

    // 실패시 에러페이지로 이동 
    this.onFailed(function (data) {
        GentleServiceError.createErrorHandler('system');
    });


    // AJAX 통신 
    this.url = '/sso/login-check';
    this.method = 'post';
    this.send();

}

GentleAppState.loginCheckToken = function () {
    document.getElementById('iframeSSOProcess').onload = function() {
        document.getElementById('iframeSSOProcess').contentWindow.postMessage(
            {
                key: 'checkLogout',
                msg:"",
                from: 'parent',
                to: 'iframe',
            }, 'https://shop-api-ga.atomy.com/') // ssoUrl = 'https://shop-api-ga.atomy.com/'
    };
}


GentleAppState.getGlobalToken = function () {
        document.getElementById('iframeSSOProcess').onload = function() {
            document.getElementById('iframeSSOProcess').contentWindow.postMessage(
                {
                    key: 'getSSOToken',
                    msg:"",
                    from: 'parent',
                    to: 'iframe',
                }, ssoUrl) // ssoUrl = 'https://shop-api-ga.atomy.com/'
        };
    }

GentleAppState.setGlobalToken = function () {
        // console.log("AtomyUserToken", GentleAppState.AtomyUserToken)
        // console.log("AtomyRefreshToken", GentleAppState.AtomyRefreshToken)

        document.getElementById('iframeSSOProcess').onload = function() {
            document.getElementById('iframeSSOProcess').contentWindow.postMessage(
                {
                    key: 'setSSOToken',
                    msg: {
                    token: GentleAppState.AtomyUserToken,
                    refreshToken: GentleAppState.AtomyRefreshToken,
                },
                    from: 'parent',
                    to: 'iframe',
                }, ssoUrl) // ssoUrl = 'https://shop-api-ga.atomy.com/'
        };
}

// FrontEnd 퍼소나 및 언어를 변경합니다 
GentleAppState.setAppState = function () {
    console.log('GentleAppState.setAppState', this.persona);
    this.$appRoot.removeClass('persona-consulting');
    this.$appRoot.addClass('persona-' + this.persona);
    this.$htmlRoot.attr('data-lang', this.lang);
  
}

// 폰트크기를 조정합니다 
// @fontSzie : (large|middle|small)
GentleAppState.setAppFont = function (fontSize) {
    this.$htmlRoot.removeClass();
    this.$htmlRoot.addClass("font-" + fontSize);
    localStorage.setItem(Const.Storage.fontSize, fontSize);
}

GentleAppState.setConsultingButton = function () {
    console.log('setConsultingButton');

    const text = '상담종료'; // GentleLang.translate(GentleLang.type.Logout)
    this.$loginButtonSelector.text(text);
    this.$loginButtonSelector.unbind();
    const button = this.$loginButtonSelector;
    this.$loginButtonSelector.on('click', function () {
        GentleComponentBubble.insertUserBubble({
            html: '상담종료',
            send: false,
        });
        GentleServiceConsulting.TalkEnd();
        button.unbind();
        GentleAppState.setLoginButton();        
        GentleAppState.setAppState();
    });
}

// FrontEnd 로그인 버튼 상태를 변경합니다  
GentleAppState.setLoginButton = function () {
    if (this.isLogin === true) {
        const text = GentleLang.translate(GentleLang.type.Logout)
        this.$loginButtonSelector.text(text);
        this.$loginButtonSelector.on('click', function () {
            GentleComponentBubble.insertUserBubble({
                html: GentleLang.translate(GentleLang.type.Logout)
            });
        });
        
    } else {
        const text = GentleLang.translate(GentleLang.type.Login)
        this.$loginButtonSelector.text(text);
        this.$loginButtonSelector.on('click', function () {
            GentleComponentBubble.insertUserBubble({
                html: GentleLang.translate(GentleLang.type.Login)
            });
        });
    }
}

// FrontEnd 한영 버튼 상태를 변경합니다  
GentleAppState.setGlobalButton = function () {
    let hostKrURL
    let hostEnURL
    let kDev = '/'+ Const.ATOMY_HOME.kr.dev
    let eDev = '/'+ Const.ATOMY_HOME.en.dev
    let kPrd = '/'+ Const.ATOMY_HOME.kr.prd
    let ePrd = '/'+ Const.ATOMY_HOME.en.prd
    let urlArr = (window.location.href).split('/');
    let newArr = urlArr.slice(0,-1)
    let result ='';


    if (GentleAppState.lang === 'kr') {
        console.log('국문봇입니다.',window.location.href)
        GentleAppState.$globalENButtonSelector.children('img').remove();
    } else {
        console.log('영문봇입니다.',window.location.href)
        GentleAppState.$globalKRButtonSelector.children('img').remove();    
    }
    
    
        if(GentleAppState.serverProfile === 'prd'){ //개발서버
             hostKrURL = kPrd
        }else{ 
             hostKrURL = kDev
        }
   
        if(GentleAppState.serverProfile === 'prd'){ 
             hostEnURL = ePrd
        }else{
             hostEnURL = eDev
        }
    
    GentleAppState.$globalKRButtonSelector.on('click', function () {
        
        result = newArr.join('/')
       

        // console.log('asdfasdfasdfas', Const.ATOMY_HOME.kr.dev, hostEnURL)

        result+=(hostKrURL);
        window.location.href = result;
        console.log('한글 최종주소', result)
        
    });
    GentleAppState.$globalENButtonSelector.on('click', function () {
        
        result = newArr.join('/')

        
        result+=(hostEnURL);
        window.location.href = result;
        console.log('영문 최종주소', result)
});
}



export default GentleAppState;